"use client";

import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LEspritUzesInside() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222223" id="curated-excellence" ref={sectionRef} className="relative w-full bg-background overflow-hidden py-24 lg:py-32">
      {}
      <div className={`absolute top-0 right-0 w-[600px] h-[600px] lg:w-[800px] lg:h-[800px] -mr-[20%] -mt-[10%] opacity-[0.03] pointer-events-none transition-opacity duration-1000 ${isSectionVisible ? "opacity-[0.08]" : "opacity-0"}`} style={{
      backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/stage_light_glow.png')",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-start-1 lg:col-end-9 z-20 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="bg-card/40 backdrop-blur-md border border-border/40 p-8 md:p-12 lg:p-16 rounded-md shadow-2xl relative overflow-hidden">
              {}
              <div className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/theatrical_grain.png')]" />
              
              <div className="relative z-10">
                <h2 className="text-3xl md:text-4xl lg:text-6xl font-default font-bold mb-8 text-foreground tracking-widest uppercase">
                  The Standard <span className="text-primary italic font-serif lowercase">of Stars</span>
                </h2>
                
                <div className="font-default text-lg md:text-xl text-foreground/90 space-y-6 leading-relaxed">
                  <p>
                    At International Experiences, we don't just find talent; we curate the extraordinary. Our scouting process is a global odyssey, seeking those rare performers who possess the power to command the world's most prestigious stages.
                  </p>
                  <p>
                    From the silent grace of a prima ballerina to the gravity-defying feats of elite circus artists, every individual on our roster undergoes a rigorous selection process. We look for more than technical mastery—we seek the "starlight" that transforms a performance into a legacy.
                  </p>
                  <p>
                    Our agency serves as the bridge between raw brilliance and global spectacle. By maintaining an exclusive circle of musicians, dancers, and acrobats, we ensure that every production we touch is imbued with an unparalleled level of cinematic luxury and professional excellence.
                  </p>
                  <p className="italic text-primary font-serif">
                    We are the architects of the world's most breathtaking performances.
                  </p>
                </div>

                
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-start-8 lg:col-end-13 z-10 mt-12 lg:mt-24 lg:-ml-8 transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            
          </div>

        </div>
      </div>
    </section>;
}